var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartBlackWithHole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.000000, -6.000000) translate(10.000000, 8.000000)",
    stroke: "currentColor",
    strokeWidth: 4,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.2409425,40.4281733 C75.0304733,41.3021778 74.6634925,42.82612 74.14,45 C72.7236859,48.9969583 68.9404699,51.6660493 64.7,51.66 L21.78,51.66",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.76,0.8 L6.76,0.8 C10.3411958,0.986378344 13.2862525,3.68811122 13.78,7.24 L21.38,51"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.62,
    cy: 75.6,
    r: 7.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.2,
    cy: 75.6,
    r: 7.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6884721 16.8276249L47.8645967 16.8276249"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartBlackWithHole);
export default __webpack_public_path__ + "static/media/Shopping Cart Black With Hole.20e2c1edc8f4280ecc34fe23a563bf9c.svg";
export { ForwardRef as ReactComponent };